<div class="headerForm w-full flex justify-center items-center py-2 text-ink-500 text-sm font-medium">
  <h3>{{ Text }}</h3>
</div>
